export enum BudgetTypes {
  SEVERE = 'severe',
  MILD = 'mild',
  MODERATE = 'moderate',
}
